module.exports = __webpack_public_path__ + "img/pexels-andrea-piacquadio-927451.fc49182c.jpg";